export default {"src":"/_next/static/media/usdt.211437a6.svg","height":2500,"width":2500};